import React from 'react';
import { Control, useController } from 'react-hook-form';
import { Calendar } from '@/components/design-system/Calendar';
import dayjs from 'dayjs';

interface Props {
  control: Control<Record<string, unknown>>;
  name: string;
  title: string;
  subtitle?: string;
  required?: boolean;
  minDate?: string | null;
  maxDate?: string;
  disabled?: boolean;
  defaultDate?: string;
}

const DatePickerWrapper: React.FC<Props> = ({
  control,
  name,
  required = false,
  minDate,
  maxDate,
  disabled = false,
  defaultDate,
}) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    rules: {
      required: required ? 'Please select a date' : false,
    },
  });

  // Convert string dates to Date objects
  const minDateTime = minDate
    ? dayjs(minDate).toDate()
    : dayjs('1900-01-01').toDate();
  const maxDateTime = maxDate ? dayjs(maxDate).toDate() : dayjs().toDate();

  // Convert field.value to Date if it's a string, or use defaultDate if no value
  const selectedDate = field.value
    ? typeof field.value === 'string'
      ? dayjs(field.value).toDate()
      : (field.value as Date)
    : defaultDate
      ? dayjs(defaultDate).toDate()
      : undefined;

  return (
    <div>
      <Calendar
        mode="single"
        selected={selectedDate}
        defaultMonth={selectedDate}
        onSelect={field.onChange}
        disabled={disabled}
        fromDate={minDateTime}
        toDate={maxDateTime}
        initialFocus
        captionLayout="dropdown-buttons"
      />
      {error && <p className="text-red-500 mt-2">{error.message}</p>}
    </div>
  );
};

export default DatePickerWrapper;
